import React from "react";
import { Link } from "react-router-dom";

/**
 * Site logo — Agendik wordmark + 4-branch medical cross (equal arms, straight
 * edges, white on blue) rendered inline. NOT used for the app icon or
 * favicon: those keep their rounded-corner glyph.
 */
export default function Logo({ compact = false }) {
  return (
    <Link to="/" data-testid="logo-home-link" className="flex items-center gap-2.5 group">
      <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow">
        <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect x="9" y="4" width="6" height="16" fill="#FFFFFF"/>
          <rect x="4" y="9" width="16" height="6" fill="#FFFFFF"/>
        </svg>
      </div>
      {!compact && (
        <span className="text-xl font-extrabold tracking-tight text-slate-900 dark:text-white">
          Agendik
        </span>
      )}
    </Link>
  );
}
